var exports = {
  "a": "Box__bLsCU5",
};

module.exports = exports;
